<template>
  <data-section
    theme="red"
    title="商品建議書"
    :isLoading="isLoading"
    :datas="datas"
    :_fields="
      [
        {
          name: '險種',
          key: 'productname',
          width: 274,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'insuredpersonname',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortInsuredpersonname'],
          orderByMultiType: ['asc']
        },
        { name: '繳費\n年期', key: 'year', width: 55 },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 49,
          className: 'text-left'
        },
        {
          name: '建立日期',
          key: 'insurancedate',
          width: 95,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc']
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right'
        },
        {
          name: '保費/繳別',
          key: 'bknm',
          width: 138,
          thClassName: 'text-right',
          className: 'text-right',
          sortable: true,
          orderByMultiKey: [
            'sortBknm',
            'isprimarycontract',
            'money',
            'longPremium'
          ],
          orderByMultiType: ['asc', 'adesc', 'asc', 'asc']
        },
        { name: '受益人', key: 'bnf', width: 99 }
      ].concat(_fields)
    "
    @toggle="(isShow) => $router.assignQuery({ ProductSuggestShow: isShow })"
    :initShow="$route.query['ProductSuggestShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="
          Object.assign({}, props, {
            datas: proccessDatas
          })
        "
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`ProductSuggestSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`ProductSuggestSort`]
            ? JSON.parse($route.query[`ProductSuggestSort`])
            : {}
        "
      >
        <template slot="productname" scope="item">
          <div v-if="item.data.isprimarycontract">
            <div class="font-13">
            商品建議書
            </div>  
            <div>
              {{ item.data.productname }}
              {{ item.data.prodid ? `(${item.data.prodid})` : "" }}
            </div>
          </div>
          <div v-else>
            <div style="margin-left: 1em; text-indent: -1em">
              <span style="text-shadow: 0px 1px grey" class="text-gray">
                <strong>└</strong>
              </span>
              {{ item.data.productname }}
              {{ item.data.prodid ? `(${item.data.prodid})` : "" }}
            </div>
          </div>
        </template>
        <template slot="applicant" scope="item">
          <span v-if="item.data.c111_apc!= ''" @click="routeToCustDetail(item.data.c111_apc , item.data.applicant)" class="link text-underline">
            {{ item.data.applicant | truncate }}
          </span>
          <div  v-else>
              {{ item.data.applicant | truncate }}
          </div>
        </template>
        <template slot="year" scope="item">
          {{ item.data.year.padLeft(2, "0") }}
          <span v-if="item.data.year_type === '2'">歲</span>
        </template>
        <template slot="insuredpersonname" scope="item">
          <div
            @click="routeToCustDetail(item.data.insuredpersonid , item.data.insuredpersonname)"
            class="link text-underline"
          >
            {{ item.data.insuredpersonname | truncate }}
          </div>
        </template>
        <template slot="amountofinsurance" scope="item">
          <div
            v-if="item.data.schemename && item.data.quantity"
            class="text-right pre-formatted"
          >
            {{
              item.data.schemename && item.data.schemename.includes("_1")
                ? `計畫${item.data.schemename}：\n`
                : `計畫${item.data.schemename}：\n日額`
            }}{{ `${item.data.quantity}元` }}
          </div>
          <div v-else class="text-right">
            {{ item.data.amountofinsurance }}
          </div>
        </template>
        <template slot="bknm" scope="item">
          <div v-if="item.data.premium">
            {{ item.data.money }} {{ item.data.premium | numberFormat }}
          </div>
          <div>{{ item.data.paymentway }}</div>
          <div v-if="item.data.bknm || item.data.card_acnt_no">
            {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
          </div>
        </template>
        <template slot="bnf" scope="item">
          <div
            v-for="(name, key) in {
              bnf_death_nm: '身故',
              bnf_matag_nm: '滿期',
              bnf_annuity_nm: '年金',
              bnf_birth_nm: '祝壽'
            }"
            :key="key"
          >
            <span
              v-if="item.data[key]"
              :set="(names = item.data[key].split(','))"
            >
              {{ name }}：
              <span v-for="(name, index) in names" :key="index">
                <truncate-tool :content="name"></truncate-tool>
                {{ names.length - 1 > index ? "、" : "" }}
              </span>
            </span>
          </div>
          <div
            v-if="
              !item.data.bnf_death_nm &&
              !item.data.bnf_matag_nm &&
              !item.data.bnf_annuity_nm &&
              !item.data.bnf_birth_nm
            "
          >
            一一
          </div>
        </template>

        <template slot="action" scope="item">
          <div v-if="item.data.isMyself && item.data.isprimarycontract">
            <a
              role="button"
              class="text-red text-underline"
              @click="doDelete(item.data)"
            >
              刪除
            </a>
          </div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import TruncateTool from "./TruncateTool";
import { deleteOtherLifeInsurance } from "@/service";
import { mvCommonMixin } from '@/desktop/views/mv/mixins/common';

const { moment } = window;
export default {
  mixins: [InsuranceMixins, mvCommonMixin],
  components: {
    TruncateTool
  },
  methods: {
    async doDelete(data) {
      const productName =
        `${data.policynumber} ${data.productname} ` +
        (data.prodid ? `(${data.prodid})` : "");
      const messageBuilder = data.isprimarycontract
        ? this.buildDeleteMessage
        : this.buildDeleteSubMessage;
      await this.$deleteConfirm(messageBuilder(productName));

      await this.deleteSuccessHandler(
        deleteOtherLifeInsurance({
          contract_type: data.contract_type,
          contract_id: data.contract_id,
          policyid: data.policyid
        })
      );
      this.isLoading = true;
      this.$bus.emit(
        "other-life-insurance.get",
        () => (this.isLoading = false)
      );
    }
  },
  computed: {
    proccessDatas() {
      const datas = this.datas
        .map((person) =>
          person.majorpolicyinfolist.map((primary) => {
            const primaryData = primary.policyinfolist[0];
            return primary.policyinfolist.map((data) =>
              Object.assign({}, data, {
                insuredpersonname: person.insuredpersonname,
                policynumber: primary.policynumber,
                c111_apc: primary.c111_apc,
                insuredpersonid: person.insuredpersonid,
                applicant: primary.applicant,
                card_acnt_no: primary.card_acnt_no,
                bknm: primary.bknm,
                trClassName: data.isprimarycontract ? "bg-white" : "bg-gray",
                longPremium: data.premium.padLeft(20, "0"),
                isMyself: data.relation == "本人",
                sortProductname: this.mergeString(
                  primaryData.prodid,
                  primary.policyid
                ),
                sortApplicant: this.mergeString(
                  primary.applicant,
                  primary.policyid
                ),
                sortInsuredpersonname: this.mergeString(
                  primary.insuredpersonname,
                  primary.policyid
                ),
                sortInsuranceADDate: this.mergeString(
                  moment(primaryData.insurancedate).getADDate(),
                  primary.policyid
                ),
                sortBknm: this.mergeString(
                  // 沒有數字可以被放一起
                  !primaryData.premium ? "" : "_",
                  primaryData.money,
                  // 左邊補0讓文字可以被排序
                  primaryData.premium.padLeft(20, "0"),
                  primary.policyid
                )
              })
            );
          })
        )
        .flat()
        .flat();

      const { _ } = window;
      const MASTER_CONTRACT = "1";
      const relationOrder = _.invert(["本人", "配偶", "子女"]);

      const findRelationInDatas = (relation) =>
        _.filter(datas, {
          contract_type: MASTER_CONTRACT,
          relation
        });
      // 本人主約
      const myselfContracts = findRelationInDatas("本人");
      // 配偶主約
      let spouseContracts = findRelationInDatas("配偶");
      // 子女主約
      let sonContracts = findRelationInDatas("子女");

      // 附約
      let subContracts = _.reject(datas, {
        contract_type: MASTER_CONTRACT
      });

      // 取出屬於這張單的內容，"並從原資料中移除"
      const pickBelongContract = (policyid) => (datas) =>
        _.remove(datas, { policyid: policyid });

      return myselfContracts
        .reduce((result, myselfContract) => {
          const pickBelongThisContract = pickBelongContract(
            myselfContract.policyid
          );
          return (
            result
              // 這張單的本人主約
              .concat(myselfContract)
              // 屬於這張單的附約
              .concat(
                _.map(
                  _.groupBy(
                    pickBelongThisContract(subContracts),
                    "contract_id"
                  ),
                  (datas) => _.orderBy(datas, (x) => relationOrder[x.relation])
                ).flat()
              )
              // 屬於這張單的配偶主約
              .concat(pickBelongThisContract(spouseContracts))
              // 屬於這張單的子女主約
              .concat(pickBelongThisContract(sonContracts))
          );
        }, [])
        .concat(spouseContracts)
        .concat(sonContracts)
        .concat(subContracts);
    }
  }
};
</script>
